import { cn } from '../../lib/utils';
import { CURRENT_INSTANCE } from '../../tenant';

interface UserMessageProps {
  message: string;
}

function UserMessage(props: UserMessageProps) {
  const chatClasses = CURRENT_INSTANCE.theme.classes?.chat;
  return (
    <div
      className={cn(
        'question-message-container w-full md:w-3/4 text-[0.95rem] self-end relative whitespace-normal break-words bg-[hsl(var(--xircle-main))] text-white ml-auto mb-4 px-4 py-3 rounded-2xl shadow-[0_10px_30px_rgba(15,23,42,0.12)] animate-enter',
        chatClasses?.userMessage
      )}
    >
      {props.message}
    </div>
  );
}

export default UserMessage;
